import { Component, ViewContainerRef, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PsNotifyService, PsModalLoadingComponent } from 'porto-seguro-guide';
import { LoadingService } from './shared/services/components/loading.service';
import { UsuarioService } from './shared/services/acordo-ressarcimento/api/services';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'front-referencia-new';

  @ViewChild('modalLoadingSpin') loading: PsModalLoadingComponent;

  public codigoRamo: number;
  public perfil = "ESCRITORIO";
  public dinamica = "ABERTURA_DA_PORTA_SEM_CAUTELA";
  public origemAcessoWorkflow = true;
  public flagMenuLoteFatura: boolean;
  public flagMenuConciliacao: boolean;

  public flagPageLoteFaturaRepasse: boolean;
  public flagPageLoteFaturaConsulta: boolean;
  public flagPageLoteFaturaPagador: boolean;
  public flagPageExtratoImportacao: boolean;
  public flagPageExtratoConsulta: boolean;
  public flagPageLoteHonorarioConsulta: boolean;
  public flagPageConciliacao: boolean;
  public flagPageValidacaoConciliacao: boolean;

  public flagMenuRelatorio: boolean;
  public flagPageRelatorioAcordos: boolean;
  public flagPageRelatorioParcelas: boolean;
  public flagPageRelatorioFinanceiro: boolean;
  public flagMenuDominio: boolean;
  public flagAjusteManual: boolean;

  public token: string;

  constructor(
    public viewContainerRef: ViewContainerRef,
    private router: Router,
    @Inject(PsNotifyService) private _psNotifyService: PsNotifyService,
    private _viewContainerRef: ViewContainerRef,
    private usuarioService: UsuarioService,
    private loadingService: LoadingService) {
  }

  ngOnInit() {
    this.loadingService.loading = this.loading;
    this.recuperarDadosUsuarioLogado();
    console.log(sessionStorage);
    console.log('versao 05-02-2026 11h30min');
  }

  goToProposta() {
    this.router.navigate(['/proposta']);
  }

  goToHome() {
    this.router.navigate(['']);
  }

  getCodigoRamo() {
      return this.codigoRamo;
  }

  recuperarDadosUsuarioLogado() {
      this.usuarioService.recuperarDadosUsuario().subscribe(result => {

        sessionStorage.setItem('nomeEscritorio', result.nomeEscritorio);
        if( result.codigoEscritorio ) {
            sessionStorage.setItem('codigoEscritorio', JSON.stringify(result.codigoEscritorio));
        } else {
            sessionStorage.setItem('codigoEscritorio', "");
        }

        sessionStorage.setItem('nomeUsuario', result.nomeUsuario);
        sessionStorage.setItem('isEscritorio', JSON.stringify(result.flagEscritorio));
        sessionStorage.setItem('perfis', JSON.stringify(result.perfis));
        sessionStorage.setItem('produto', JSON.stringify(result.produto));
        sessionStorage.setItem('flagAprovaProposta', JSON.stringify(result.flagAprovaProposta));
        sessionStorage.setItem('flagReprovaProposta', JSON.stringify(result.flagReprovaProposta));
        sessionStorage.setItem('flagAtualizaParcela', JSON.stringify(result.flagAtualizaParcela));
        sessionStorage.setItem('flagCancelaAcordo', JSON.stringify(result.flagCancelaAcordo));
        sessionStorage.setItem('flagAlteraTerceiro', JSON.stringify(result.flagAlteraTerceiro));
        sessionStorage.setItem('flagNotaFiscal', JSON.stringify(result.flagNotaFiscal));
        sessionStorage.setItem('flagAprovaHonorario', JSON.stringify(result.flagAprovaHonorario));
        sessionStorage.setItem('flagReprovaHonorario', JSON.stringify(result.flagReprovaHonorario));
        sessionStorage.setItem('flagGerarHonorario', JSON.stringify(result.flagGeraHonorario));
        sessionStorage.setItem('flagReprovarTransacao', JSON.stringify(result.flagReprovaTransacao));
        sessionStorage.setItem('flagAprovarTransacao', JSON.stringify(result.flagAprovaTransacao));
        sessionStorage.setItem('flagCancelaTransacao', JSON.stringify(result.flagCancelaTransacao));
        sessionStorage.setItem('flagExcelParcelasHonorario', JSON.stringify(result.flagExcelParcelasHonorario));
        sessionStorage.setItem('flagDetalheHonorario', JSON.stringify(result.flagDetalheHonorario));
        sessionStorage.setItem('flagVisualizaLinhaCredito', JSON.stringify(result.flagVisualizaLinhaCredito));
        sessionStorage.setItem('flagMenuLoteFatura', JSON.stringify(result.flagMenuLoteFatura));
        sessionStorage.setItem('flagPageLoteFaturaRepasse', JSON.stringify(result.flagPageLoteFaturaRepasse));
        sessionStorage.setItem('flagPageLoteFaturaConsulta', JSON.stringify(result.flagPageLoteFaturaConsulta));
        sessionStorage.setItem('flagPageLoteFaturaPagador', JSON.stringify(result.flagPageLoteFaturaPagador));
        sessionStorage.setItem('flagPageExtratoImportacao', JSON.stringify(result.flagPageExtratoImportacao));
        sessionStorage.setItem('flagPageExtratoConsulta', JSON.stringify(result.flagPageExtratoConsulta));
        sessionStorage.setItem('flagPageLoteHonorarioConsulta', JSON.stringify(result.flagPageLoteHonorarioConsulta));
        sessionStorage.setItem('flagPageConciliacao', JSON.stringify(result.flagPageConciliacao));
        sessionStorage.setItem('flagPageValidacaoConciliacao', JSON.stringify(result.flagPageValidacaoConciliacao));
        sessionStorage.setItem('flagMenuConciliacao', JSON.stringify(result.flagMenuConciliacao));

        sessionStorage.setItem('flagMenuRelatorio', JSON.stringify(result.flagMenuRelatorio));
        sessionStorage.setItem('flagPageRelatorioAcordos', JSON.stringify(result.flagPageRelatorioAcordos));
        sessionStorage.setItem('flagPageRelatorioParcelas', JSON.stringify(result.flagPageRelatorioParcelas));
        sessionStorage.setItem('flagPageRelatorioFinanceiro', JSON.stringify(result.flagPageRelatorioFinanceiro));
        sessionStorage.setItem('flagMenuDominio', JSON.stringify(result.flagMenuDominio));
        sessionStorage.setItem('flagAjusteManual', JSON.stringify(result.flagAjusteManual));


        sessionStorage.setItem('token', environment.token);

        this.codigoRamo = JSON.parse(sessionStorage.getItem('produto'));
        this.flagMenuLoteFatura = JSON.parse(sessionStorage.getItem('flagMenuLoteFatura'));
        this.flagPageLoteFaturaRepasse = JSON.parse(sessionStorage.getItem('flagPageLoteFaturaRepasse'));
        this.flagPageLoteFaturaConsulta = JSON.parse(sessionStorage.getItem('flagPageLoteFaturaConsulta'));
        this.flagPageLoteFaturaPagador = JSON.parse(sessionStorage.getItem('flagPageLoteFaturaPagador'));
        this.flagPageExtratoImportacao = JSON.parse(sessionStorage.getItem('flagPageExtratoImportacao'));
        this.flagPageExtratoConsulta = JSON.parse(sessionStorage.getItem('flagPageExtratoConsulta'));
        this.flagPageLoteHonorarioConsulta = JSON.parse(sessionStorage.getItem('flagPageLoteHonorarioConsulta'));
        this.flagPageConciliacao = JSON.parse(sessionStorage.getItem('flagPageConciliacao'));
        this.flagPageValidacaoConciliacao = JSON.parse(sessionStorage.getItem('flagPageValidacaoConciliacao'));
        this.flagMenuConciliacao = JSON.parse(sessionStorage.getItem('flagMenuConciliacao'));

        this.flagMenuRelatorio = JSON.parse(sessionStorage.getItem('flagMenuRelatorio'));
        this.flagPageRelatorioAcordos = JSON.parse(sessionStorage.getItem('flagPageRelatorioAcordos'));
        this.flagPageRelatorioParcelas = JSON.parse(sessionStorage.getItem('flagPageRelatorioParcelas'));
        this.flagPageRelatorioFinanceiro = JSON.parse(sessionStorage.getItem('flagPageRelatorioFinanceiro'));
        this.flagMenuDominio = JSON.parse(sessionStorage.getItem('flagMenuDominio'));
        this.flagAjusteManual = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
        this.token = sessionStorage.getItem('token');
      });
  }

  public ramoAcordoChange(evt) {
    var target = evt.target;
    if (target.selectedIndex == 0) {
      this.codigoRamo = 531;
      this.origemAcessoWorkflow = true;
    } else if (target.selectedIndex == 1) {
      this.codigoRamo = 531;
      this.origemAcessoWorkflow = false;
    } else {
      this.codigoRamo = 746;
      this.origemAcessoWorkflow = false;
    }
    console.log(this.codigoRamo)
    this.goToHome();
  }

  public perfilChange(evt) {
    var target = evt.target;
    if (target.selectedIndex == 0) {
      this.perfil = "ESCRITORIO";
    } else if (target.selectedIndex == 1) {
      this.perfil = "GESTOR";
    } else if (target.selectedIndex == 2) {
      this.perfil = "SENIOR";
    } else if (target.selectedIndex == 3) {
      this.perfil = "ADM";
    } else if (target.selectedIndex == 4) {
      this.perfil = "GERENTE";
    } else {
      this.perfil = "SUPERINTENDENTE";
    }
  }

  public dinamicaChange(evt) {
    var listaDinamica = ["ABERTURA_DA_PORTA_SEM_CAUTELA", "ANIMAIS_NA_PISTA", "ATROPELAMENTO", "BURACO_NA_PISTA", "CHUVA_DE_GRANIZO",
      "COLISAO_CAUSADA_POR_TERCEIRO_PROJETADO", "COLISAO_EM_VEICULO_ESTACIONADO", "COLISAO_FRONTAL_NAO_USAR",
      "COLISAO_NA_TRASEIRA", "COMPORTAS_SABESP", "CONTRAMAO_DE_DIRECAO", "CRUZAMENTO_DOTADO_DE_SEMAFORO",
      "CRUZAMENTO_DOTADO_DE_SINAL_PARE", "CRUZAMENTO_NAO_SINALIZADO", "DANO_ATO_DOLOSO_PROVOCADO_POR_TERCEIRO",
      "DANO_CONDOMINIO_RESIDENCIAL", "DANO_ESTABELECIMENTO_COMERCIAL", "DANO_VIA_PUBLICA", "DANOS_AOS_VIDROS",
      "DERRAPAGEM", "EMBRIAGUEZ_NAO_USAR", "ENCHENTE_CONDOMINI_0_RESID_COMERCIAL", "ENCHENTE_ESTABELECIMENTO_COMERCIAL",
      "ENCHENTE_ESTACIONAMENTO_PARTICULAR", "ENCHENTE_VIA_PUBLICA", "ENGAVETAMENTO", "FALHA_NA_REGULACAO", "FALHA_OPERACIONAL_PAGTO_OFICINA",
      "FALHA_PRESTADOR_VP", "FECHADA_OBSTRUIR", "FRENAGEM_BRUSCA", "FURTO_CONDOMINIO_COMERCIAL", "FURTO_CONDOMINIO_RESIDENCIAL",
      "FURTO_EM_VIA_PUBLICA_CARTAO_ZONA_AZUL", "FURTO_ESCOLAS_ESTADUAIS_MUNICIPAIS", "FURTO_ESTAB_COM_SEM_CONT_ENTR_SAIDA",
      "FURTO_ESTACIONAMENTO_PARTICULAR", "FURTO_PARQUES_ESTADUAIS_MUNICIPAIS", "FURTO_POR_MELIANTES_EM_VIA_PUBLICA",
      "FURTO_UNIVERSIDADES_ESCOLAS_E_PARQUE", "INCENDIO", "INTERCEPTACAO_DE_TRAJETORIA", "INVASAO_OU_AVANCO_NA_VIA_PREFERENCIAL",
      "MARCHA_A_RE", "MUDANCA_DE_FAIXA", "NAO_USAR_COLISAO_LATERAL", "OBJETO_NA_PISTA", "OLEO_NA_PISTA", "PASSAGEM_DE_NIVEL",
      "PERDA_DE_DIRECAO", "PREFERENCIA_VEICULO_TRAFEGAVA_DIREITA", "QUEDA_DE_ARVORE", "QUEDA_DE_OBJETO_DO_VEIC_TERCEIRO",
      "RACHA_NAO_USAR", "RECALL_ACOES_CONTRA_A_MONTADORA", "REPAROS_MAL_EXECUTADOS_CARRO_RESERVA", "REPETICAO_DE_INDEBITO",
      "ROTATORIA", "ROUBO_CAMPUS_UNIVERSITARIO_FED_EST_MUN", "ROUBO_CONDOMINIO_COMERCIAL", "ROUBO_CONDOMINIO_RESIDENCIAL",
      "ROUBO_EM_VIA_PUBLICA_CARTAO_ZONA_AZUL", "ROUBO_ESCOLAS_ESTADUAIS_MUNICIPAIS", "ROUBO_ESTACIONAMENTO_PARTICULAR",
      "ROUBO_PARQUES_ESTADUAIS_MUNICIPAIS", "ROUBO_POR_MELIANTES_EM_VIA_PUBLICA", "ROUBOESTAB_COMERCIAL_S_CONTR_ENTR_SAIDA",
      "SAMARCO", "SEM_ANALISE", "SEMAFORO_COM_DEFEITO", "SINISTRO_COM_AERONAVE", "VEICULO_DIRIGIDO_POR_QUEM_O_FURTOU", "VEICULO_PARADO_EM_RODOVIA"];
    this.dinamica = listaDinamica[evt.target.selectedIndex];
  }

  public createAlert(msg: any, type: any) {
    this._psNotifyService.createNotify(msg, type, this._viewContainerRef, true, 10000);
  }

  public pause(milliseconds) {
    var startPoint = new Date().getTime();
    while (new Date().getTime() - startPoint <= milliseconds) {/* wait */ }
  }

}
